/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { Row } from "@tanstack/react-table";
import { MoreHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { toast } from "components/ui/use-toast";
import { useFilterState } from "../../ducks/filter/hooks/filterState";
import { getUserFromLocalStorage } from "@/utils/getUserFromLocalStorage";
import { useState } from "react";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { ModalTransactionReversal } from "./modal-transaction-reversal";
import TransactionDetailsModal from "./modal-transaction-reversal/details-modal";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const filterState = useFilterState();
  const tableValues = row.original as any;
  const [isLoading, setIsLoading] = useState(false);
  const { handleModal } = useDialogModal();

  const handle = async () => {
    if (tableValues.has_refund === "Não" && tableValues.opr_cod !== 182) {
      toast({
        variant: "destructive",
        description:
          "Esta transação não permite estorno. Por favor, verifique se a transação selecionada possui a opção de estorno antes de prosseguir.",
        duration: 5000,
      });
      return;
    }

    if (tableValues.operation_type === "VENDA A VISTA" || tableValues.operation_type === "SABADÃO+ PREMIADO") {
      toast({
        variant: "destructive",
        description:
          "A operação de venda não pode ser estornada, somente o pagamento.",
        duration: 5000,
      });
      return;
    }
    try {
      const dataMCX002 = {
        storeId: String(tableValues.store),
        operationDate: String(tableValues.operation_date),
        operationNumber: String(tableValues.operation_number),
        cashier: String(tableValues.cashier),
        operator: String(tableValues.operator),
        salesCtrlNumber: String(tableValues.salesctrlnumber),
        sequenceOperator: String(tableValues.sequence_operator),
        releaseSequence: String(tableValues.release_sequence),
        operationType: filterState?.filters?.advancedFilter?.operationType,
      };

      const user = getUserFromLocalStorage();
      const email = user?.email || "";
      const loginAD = email.split("@")[0];

      const dataMCX008 = {
        storeOriginId: String(tableValues.store),
        operationNumber: String(tableValues.operation_number),
        releaseSequence: String(tableValues.release_sequence),
        reversalValue: String(tableValues.value),
        user: loginAD,
      };

      handleModal({
        isOpen: true,
        element: (
          <ModalTransactionReversal
            dataMCX002={dataMCX002}
            dataMCX008={dataMCX008}
            setLoading={setIsLoading}
          />
        ),
        title: "Motivo do Estorno",
      });
    } catch (error) {
      toast({
        variant: "destructive",
        description:
          (error as any)?.data?.messages.join(", ") || "Erro ao estornar",
        duration: 5000,
      });
      throw error;
    }
  };

  const handleDetails = () => {
    handleModal({
      isOpen: true,
      element: (
        <TransactionDetailsModal
          row={row}
          operationType={filterState?.filters?.advancedFilter?.operationType}
        />
      ),
      title: "Detalhes do Estorno",
    });
  }

  console.log(row)

  return (
    <DropdownMenu >
      {!isLoading ? (
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost_none"
            className="flex h-8 w-8 p-0 data-[state=open]:bg-muted border-none bg-transparent"
          >
            <MoreHorizontal />
            <span className="sr-only">Abrir Menu</span>
          </Button>
        </DropdownMenuTrigger>
      ) : (
        <svg
          className="animate-spin h-5 w-5 text-[#2B0C1A]"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      )}
      <DropdownMenuContent align="end" className="w-[160px]">
        <DropdownMenuItem onClick={() => handleDetails()}>
          Ver Detalhes
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handle()}>Estornar</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
